import { useUserStore } from '~/stores/user'
import { syncAuthSessionHintCookie } from '~/composables/useAuthSessionHint'

/** Align session cookie with Pinia persist as early as possible on the client. */
export default defineNuxtPlugin({
  name: 'auth-session-hint',
  dependsOn: ['pinia'],
  setup() {
    const userStore = useUserStore()
    syncAuthSessionHintCookie(userStore.token)

    watch(
      () => userStore.token,
      (token) => syncAuthSessionHintCookie(token),
    )
  },
})
